import {
  StyledDatePicker,
  StyledForm,
  StyledInput,
  Container,
  LabelOptional,
  BoxLabel,
  SearchInput,
  HeadTitle,
  Title,
} from './styles'
import { Col, Form, Row } from 'antd'
import { useHealthClaimForm } from '@/contexts/healthClaimForm'
import { InsuredPersonDetailHook } from './InsuredPersonDetail.hook'

function InsuredPersonDetail() {
  const {
    search,
    setSearch,
    isCreateMode,
    isCreateOrEditMode,
    insuredPersonForm,
    isPolicyCoveragesLoading,
  } = InsuredPersonDetailHook()
  const { markEditedOnce } = useHealthClaimForm()

  return (
    <Container>
      {/* Header Section */}
      <Title>ข้อมูลผู้เรียกร้องสินไหมทดแทน</Title>
      {/* Search Insured Person Section */}
      {isCreateMode && (
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: '1.5rem' }}>
              <HeadTitle style={{ display: 'block', marginBottom: '0.5rem', color: '#374151' }}>
                ค้นหาผู้เอาประกัน
              </HeadTitle>

              <SearchInput
                id="e-claim-identity-search-input"
                data-testid="e-claim-identity-search-input"
                placeholder="ค้นหาเลขบัตรประชาชน"
                size="large"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                loading={isPolicyCoveragesLoading}
              />
            </div>
          </Col>
        </Row>
      )}

      {/* Form Section */}
      <StyledForm form={insuredPersonForm} layout="vertical" onValuesChange={markEditedOnce}>
        {/* First Row of Inputs */}
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={<HeadTitle>เลขบัตรประชาชน *</HeadTitle>}
              name="identityId"
              rules={[{ required: true, message: 'กรุณากรอกเลขบัตรประชาชน' }]}
            >
              <StyledInput
                id="e-claim-identity-input"
                data-testid="e-claim-identity-input"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={<HeadTitle>ชื่อ *</HeadTitle>}
              name="firstName"
              rules={[{ required: true, message: 'กรุณากรอกชื่อ' }]}
            >
              <StyledInput
                id="e-claim-first-name-input"
                data-testid="e-claim-first-name-input"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={<HeadTitle>นามสกุล *</HeadTitle>}
              name="lastName"
              rules={[{ required: true, message: 'กรุณากรอกนามสกุล' }]}
            >
              <StyledInput
                id="e-claim-last-name-input"
                data-testid="e-claim-last-name-input"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={<HeadTitle>วันเดือนปีเกิด *</HeadTitle>}
              name="dob"
              rules={[{ required: true, message: 'กรุณาเลือกวันเดือนปีเกิด' }]}
            >
              <StyledDatePicker
                id="e-claim-dob-input"
                data-testid="e-claim-dob-input"
                disabled={true}
                format="DD/MM/BBBB" // Format for display
                placeholder="เลือกวันเดือนปีเกิด"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Second Row of Inputs */}
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={<HeadTitle>เบอร์โทรศัพท์ *</HeadTitle>}
              name="phoneNumber"
              rules={[
                { required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' },
                { pattern: /^\d+$/, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' },
                { min: 10, message: 'กรุณากรอกเบอร์โทรศัพท์อย่างน้อย 10 หลัก' },
              ]}
            >
              <StyledInput
                id="e-claim-phone-input"
                data-testid="e-claim-phone-input"
                disabled={!isCreateOrEditMode}
                inputMode="numeric"
                minLength={10}
                maxLength={10}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label={
                <BoxLabel>
                  <HeadTitle>อีเมล</HeadTitle>
                  <LabelOptional>(ถ้ามี)</LabelOptional>
                </BoxLabel>
              }
              name="email"
              rules={[{ type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง!' }]}
            >
              <StyledInput
                id="e-claim-email-input"
                data-testid="e-claim-email-input"
                disabled={!isCreateOrEditMode}
              />
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </Container>
  )
}

export default InsuredPersonDetail
